export const RuntimeEvents = {
  ASYNC_ISOLATE_DONE: 'ASYNC_ISOLATE_DONE',
  ISOLATE_DONE: 'ISOLATE_DONE',
  ISOLATE_ENTER: 'ISOLATE_ENTER',
  ISOLATE_PENDING: 'ISOLATE_PENDING',
};
